import React from 'react';
import moment from 'moment';
class Widget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            stake: '',
            towin: '',
            price: this.props.price
        }
        this.toggleCoupon = this.toggleCoupon.bind(this);

        this.changeSingleStake = this.changeSingleStake.bind(this);
        this.changeSingleWin = this.changeSingleWin.bind(this);
        this.changeMultiStake = this.changeMultiStake.bind(this);
        this.changeToWin = this.changeToWin.bind(this);
    }
    changeToWin(value) {
        this.props.checkItems();
        this.setState({ towin: value.target.value, stake: (value.target.value / (this.props.price-1)).toFixed(2) })
    }
    changeSingleWin(o) {
        this.props.checkItems();

        this.props.changeSingleWin(o.target.id, o.target.value);
        // this.setState({ id: value.target.value, stake: value.target.value / this.props.price })
    }
    changeMultiStake(stake) {
        this.props.checkItems();
        this.setState({ stake: stake.target.value, towin: ((stake.target.value * this.props.price) - stake.target.value).toFixed(2) })
    }
    changeSingleStake(o) {
        // console.log(o.target.id);
        // console.log(o.target.value);
        this.props.changeStake(o.target.id, o.target.value);
    }
    toggleCoupon() {
        this.props.checkItems();
        this.state.open ? this.setState({ open: false }) : this.setState({ open: true });
    }
    componentDidMount() {
        this.props.checkItems();
        this.setState({ open: this.props.open })
    }
    render() {
        let items = this.props.items

        let picks = Object.keys(this.props.items).map((idApuesta) => {
            return <div key={idApuesta} className="p-1 list-group-item list-group-item-action flex-column align-items-start mt-1">

                <div className="d-flex w-100 justify-content-between" >
                    <label className="m-0 text-truncate" style={{ color: 'white' }}>{items[idApuesta].liga}</label>
                    <button type="button" className="btn button-special border border-danger btn-sm del" onClick={this.props.removeFromCupon.bind(this, idApuesta)}><i className="far fa-trash-alt"></i></button>
                </div>

                <div className="text-truncate" style={{ position: 'relative', top: -14, width: 'calc(100% - 35px)' }}> {items[idApuesta].name}</div>

                <small className="text-muted d-block" style={{ position: 'relative', top: -14 }}> {moment(items[idApuesta].time * 1000).format('MMM DD, YYYY - H:mm')}</small>

                <div className="d-flex w-100 justify-content-between" style={{ position: 'relative', top: -14 }}>
                    <small>{this.props.language(items[idApuesta].logro).text}</small>
                    <span> {items[idApuesta].odd}</span>
                </div>

                <span className="d-block" style={{ position: 'relative', top: -9 }}>
                    {this.props.language(items[idApuesta].option).text + " " + (items[idApuesta].handicap ? items[idApuesta].handicap : "")}
                </span>

            </div>

        })
        let singles = Object.keys(this.props.items).map((idApuesta) => {
            return <div key={idApuesta} className="p-1 list-group-item list-group-item-action flex-column align-items-start mt-1">

                <div className="d-flex w-100 justify-content-between" >
                    <label className="m-0 text-truncate" style={{ color: 'white' }}>{items[idApuesta].liga}</label>
                    <button type="button" className="btn button-special border border-danger btn-sm del" onClick={this.props.removeFromCupon.bind(this, idApuesta)}><i className="far fa-trash-alt"></i></button>
                </div>

                <div className="text-truncate" style={{ position: 'relative', top: -14, width: 'calc(100% - 35px)' }}> {items[idApuesta].name}</div>

                <small className="text-muted d-block" style={{ position: 'relative', top: -14 }}> {moment(items[idApuesta].time * 1000).format('MMM DD, YYYY - H:mm')}</small>

                <div className="d-flex w-100 justify-content-between" style={{ position: 'relative', top: -14 }}>
                    <small>{this.props.language(items[idApuesta].logro).text}</small>
                    <span> {items[idApuesta].odd}</span>
                </div>

                <span className="d-block" style={{ position: 'relative', top: -14 }}>
                    {this.props.language(items[idApuesta].option).text + " " + (items[idApuesta].handicap ? items[idApuesta].handicap : "")}
                </span>
                <div className="d-flex w-100 justify-content-between pt-1" style={{ position: 'relative', top: -9 }}>
                    <span className='mr-3'>
                        <div className="float-right input-group" style={{ display: 'inline-flex', width: 127 }}>
                            <div className="input-group-prepend ">
                                <div className="input-group-text"><i className="fas fa-dollar-sign text-green"></i></div>
                            </div>
                            <input type="number" step="0.01" min='0' max="999999999" id={idApuesta} className="form-control form-control-sm" placeholder={this.props.language().stake} value={items[idApuesta].stake} onChange={this.changeSingleStake} onBlur={this.props.saveStakes} />
                        </div>

                    </span>
                    <span className='mr-3'>
                        <div className="float-right input-group" style={{ display: 'inline-flex', width: 127 }}>
                            <div className="input-group-prepend ">
                                <div className="input-group-text"><i className="fas fa-dollar-sign text-green"></i></div>
                            </div>
                            <input type="number" step="0.01" min='0' max="999999999" id={idApuesta} className="form-control form-control-sm" placeholder={this.props.language().win} value={(items[idApuesta].win)} onChange={this.changeSingleWin} onBlur={this.props.saveStakes} />
                        </div>

                    </span>
                    {/* <small className="d-none" style={{ textAlign: 'center' }}>{this.props.language().win} <span style={{ fontSize: 16 }}>${(items[idApuesta].stake * items[idApuesta].price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span></small> */}
                </div>

            </div>

        })


        let totalStake = parseFloat(Object.keys(items).reduce(function (sum, key) {
            return sum + parseFloat(items[key]['stake']);
        }, 0));
        let totalWin = parseFloat(Object.keys(items).reduce(function (sum, key) {
            return sum + parseFloat(items[key]['stake'] * items[key]['price']) - parseFloat(items[key]['stake']);
        }, 0));



        return <div>

            <div className="chat-popup rounded-top" id="myForm" style={{ display: 'block', height: !this.state.open ? 47 : 'calc(100% - 20px)', width: 300 }}>
                <div className="chat-title rounded-top " onClick={this.toggleCoupon}>
                    <h6 className="card-header" style={{ color: 'white' }}>
                        <i className="fas fa-receipt"></i>  {this.props.language().coupon}
                        <i className={this.state.open ? "fas fa-angle-double-down float-right" : "fas fa-angle-double-up float-right"}></i>
                        <span className="badge badge-danger float-right">{Object.keys(this.props.items).length}</span>

                    </h6>
                </div>
                <div className="form-container p-0 mx-2" style={{ height: '100%' }}>
                    <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
                        <li className="nav-item ">
                            <a className="nav-link active" id="straight-tab" data-toggle="tab" href="#straight" role="tab" aria-controls="straight" aria-selected="true">{this.props.language().single}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link " id="parley-tab" data-toggle="tab" href="#parley" role="tab" aria-controls="parley" aria-selected="false">{this.props.language().multiple}</a>
                        </li>

                    </ul>
                    <div className="" style={{ height: '100%' }}>
                        <div className="tab-content" id="myTabContent" style={{ height: '100%' }}>

                            <div className="tab-pane fade show active" style={{ height: '100%' }} id="straight" role="tabpanel" aria-labelledby="straight-tab">
                                <div className="picklist" style={{ overflowY: 'auto', fontSize: 14, lineHeight: '18px', width: '100%', height: 'calc(100% - 253px)', minHeight: 'calc(100% - 253px)' }}>
                                    <div className="list-group" style={{ width: 'auto ' }}>
                                        {singles}
                                    </div>
                                </div>
                                <div className="widget-footer">

                                    {/* <div htmlFor="msg" className=" justify-content-between d-none mb-1">
                                        <span style={{ position: 'relative', top: 5 }}>{this.props.language().win}:</span>
                                        
                                        
                                        <div className="float-right input-group" style={{ display: 'inline-flex', width: 150 }}>
                                            <div className="input-group-prepend ">
                                                <div className="input-group-text"><i className="fas fa-dollar-sign text-green"></i></div>
                                            </div>
                                            <input type="number"  className="form-control stake" placeholder="0" value={totalWin ? totalWin : 0}
                                                onChange={this.props.changeStakeWin}

                                            />
                                        </div>
                                    </div> */}

                                    <div htmlFor="msg" className=" justify-content-between d-flex mb-1">
                                        <span>{this.props.language().totalStake}:</span>
                                        <b style={{ fontSize: 24 }}>${totalStake ? totalStake.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0}</b>
                                    </div>
                                    <div htmlFor="msg" className=" justify-content-between d-flex mb-1">
                                        <span>{this.props.language().win}:</span>
                                        <b style={{ fontSize: 24 }}>${totalWin ? totalWin.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0}</b>
                                    </div>

                                    <button type="button" onClick={this.props.save.bind(this, this.state.stake, 'i')} className="btn btn-success btn-sm btn-block">{this.props.language().send}</button>
                                    <button type="button" onClick={this.props.removeFromCupon.bind(this, null)} className="btn btn-outline-danger btn-sm btn-block cancel">{this.props.language().clean}</button>
                                </div>
                            </div>

                            <div className="tab-pane fade " id="parley" style={{ height: '100%' }} role="tabpanel" aria-labelledby="parley-tab">
                                <div className="picklist" style={{ overflowY: 'auto', fontSize: 14, lineHeight: '18px', width: '100%', height: 'calc(100% - 269px)', minHeight: 'calc(100% - 269px)' }}>
                                    <div className="list-group" style={{ width: 'auto ' }}>
                                        <small className={this.props.multiple ? "d-none" : "bg-danger alert text-white m-1 p-1"} role="alert">
                                            {this.props.language().multiAlert}
                                        </small>

                                        {picks}
                                    </div>
                                </div>
                                <div className="widget-footer">
                                    <div htmlFor="msg" className=" justify-content-between d-flex mb-1">
                                        <span style={{ position: 'relative', top: 5 }}>{this.props.language().stake}:</span>
                                        <div className="float-right input-group" style={{ display: 'inline-flex', width: 150 }}>
                                            <div className="input-group-prepend ">
                                                <div className="input-group-text"><i className="fas fa-dollar-sign text-green"></i></div>
                                            </div>
                                            <input type="number" className="form-control stake" placeholder="0" value={this.state.stake}
                                                onChange={this.changeMultiStake}

                                            />
                                        </div>
                                    </div>
                                    <div htmlFor="msg" className=" justify-content-between d-flex mb-1">
                                        <span style={{ position: 'relative', top: 5 }}>{this.props.language().win}:</span>
                                        <div className="float-right input-group" style={{ display: 'inline-flex', width: 150 }}>
                                            <div className="input-group-prepend ">
                                                <div className="input-group-text"><i className="fas fa-dollar-sign text-green"></i></div>
                                            </div>
                                            <input type="number" className="form-control stake" placeholder="0" value={this.state.towin}
                                                onChange={this.changeToWin}

                                            />
                                        </div>
                                    </div>

                                    {/* <div htmlFor="msg" className=" justify-content-between d-flex mb-1">
                                        <span>{this.props.language().price}:</span>
                                        <b style={{ fontSize: 24 }}>{this.props.price}</b>
                                    </div> */}

                                    {/* <div htmlFor="msg" className=" justify-content-between d-none mb-1">
                                        <span>{this.props.language().win}:</span>
                                        <b style={{ fontSize: 24 }}>${(this.props.price * this.state.stake).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</b>
                                    </div> */}

                                    <button type="button" onClick={this.props.multiple ? this.props.save.bind(this, this.state.stake, 'm') : void (0)} className={this.props.multiple ? "btn btn-success btn-sm btn-block" : "btn btn-secondary btn-sm btn-block disabled"}>{this.props.language().send}</button>
                                    <button type="button" onClick={this.props.removeFromCupon.bind(this, null)} className="btn btn-outline-danger btn-sm btn-block cancel">{this.props.language().clean}</button>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>

    }
}

export default Widget;


// WEBPACK FOOTER //
// ./src/components/Widget.js